/**
 * useDeleteDataAgent Hook
 *
 * React Query mutation hook for deleting a data agent.
 */

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { dataAgentService } from '../../../api/data-agent.service';
import { DATA_AGENTS_QUERY_KEY } from './useDataAgents';
import { getErrorMessage } from '../../../lib/utils/errors';

interface UseDeleteDataAgentOptions {
  onSuccess?: () => void;
  onError?: (error: string) => void;
}

export function useDeleteDataAgent(
  tenantId: string,
  dataAgentId: string,
  options?: UseDeleteDataAgentOptions
) {
  const queryClient = useQueryClient();

  return useMutation<void, Error, void>({
    mutationFn: () => dataAgentService.deleteDataAgent(tenantId, dataAgentId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [DATA_AGENTS_QUERY_KEY, tenantId] });
      options?.onSuccess?.();
    },
    onError: (error) => {
      options?.onError?.(getErrorMessage(error));
    },
  });
}
